//Generated File 
export const BarcodePrint = `BarcodePrint`;
export const ExternalURL = `ExternalURL`;
export const GoToPlace = `GoToPlace`;
export const InternalURL = `InternalURL`;
export const NewRecord = `NewRecord`;
export const NewRecordInPopup = `NewRecordInPopup`;
export const PopupListView = `PopupListView`;
export const TextToCopy = `TextToCopy`;
export const UpdateList = `UpdateList`;
